/**
 * 🔍 Условное логирование для production
 *
 * В development: все логи работают (полезно для отладки)
 * В production: только error и warn (чистая консоль у пользователей)
 *
 * Использование:
 *   import { logger } from './utils/logger';
 *
 *   logger.log('Отладочная информация');     // только в dev
 *   logger.error('Критическая ошибка');      // всегда
 *   logger.warn('Предупреждение');           // всегда
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

export const logger = {
  /**
   * Логирование для отладки (только в development)
   * @param {...any} args - аргументы для логирования
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Логирование ошибок (всегда)
   * @param {...any} args - аргументы для логирования
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * Предупреждения (всегда)
   * @param {...any} args - аргументы для логирования
   */
  warn: (...args) => {
    console.warn(...args);
  },

  /**
   * Информационные сообщения (только в development)
   * @param {...any} args - аргументы для логирования
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Отладочные сообщения (только в development)
   * @param {...any} args - аргументы для логирования
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  /**
   * Табличный вывод (только в development)
   * @param {any} data - данные для отображения в таблице
   */
  table: (data) => {
    if (isDevelopment) {
      console.table(data);
    }
  },

  /**
   * Группировка логов (только в development)
   * @param {string} label - название группы
   */
  group: (label) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  /**
   * Закрытие группы логов (только в development)
   */
  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
};

// Экспорт по умолчанию
export default logger;
